import { render } from "./KpiSchedulerKpiCard.vue?vue&type=template&id=1fb1b80a&scoped=true&ts=true"
import script from "./KpiSchedulerKpiCard.vue?vue&type=script&lang=ts"
export * from "./KpiSchedulerKpiCard.vue?vue&type=script&lang=ts"

import "./KpiSchedulerKpiCard.vue?vue&type=style&index=0&id=1fb1b80a&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb1b80a"]])

export default __exports__